export const homeObjOne = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Financial Coaching',
    headline: 'Take Control of Your Financial Future with Cash Coach',
    description:
      'Get personalized guidance to improve your budgeting, savings, and overall financial health. Cash Coach helps you stay on track with your financial goals.',
    buttonLabel: 'Get Started',
    imgStart: '',
    img: 'images/svg-1.svg', // Kept original image
    alt: 'Financial Coaching',
};

export const homeObjTwo = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Expense Tracking',
    headline: 'Monitor Your Spending with E-Cash Finance Manager',
    description:
      'Track your expenses in real-time and see where your money is going. Stay updated on your financial health with detailed insights and analytics.',
    buttonLabel: 'Learn More',
    imgStart: '',
    img: 'images/svg-2.svg', // Kept original image
    alt: 'Expense Tracking',
};

export const homeObjThree = {
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Savings Goals',
    headline: 'Plan and Achieve Your Savings Goals',
    description:
      'Set specific savings targets and let E-Cash Finance Manager guide you along the way. Track your progress and get notified when you’re close to achieving your goals.',
    buttonLabel: 'Start Saving',
    imgStart: 'start',
    img: 'images/svg-3.svg', // Kept original image
    alt: 'Savings Goals',
};

export const homeObjFour = {
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Financial Insights',
    headline: 'Gain Deeper Insights into Your Financial Habits',
    description:
      'Analyze your spending and saving patterns to make informed financial decisions. With E-Cash Finance Manager, you get all the tools you need to enhance your financial well-being.',
    buttonLabel: 'Sign Up Now',
    imgStart: 'start',
    img: 'images/svg-8.svg', // Kept original image
    alt: 'Financial Insights',
};
